import { SingleLineChart } from "@/shared/charts/SingleLineChart";
import { TrendingData } from "@/pages/caster/data-entry/models/caster.models";
import { Probe } from "../../models/lmf.models";

interface Props {
  probes: Probe[];
}

export const SteelTemperatureChart = ({ probes }: Props) => {
  const trendingData: TrendingData[] = probes
    .filter((p) => p.Temperature !== null && p.Timestamp !== null)
    .sort(
      (a, b) =>
        new Date(a.Timestamp).getTime() - new Date(b.Timestamp).getTime(),
    )
    .map((p) => ({
      Datetime: new Date(p.Timestamp),
      Value: p.Temperature,
    }));

  return <SingleLineChart title="Steel Temperature" data={trendingData} />;
};
